import { Component, OnInit } from '@angular/core';
import {
    MapLayerProviderOptions,
    MapTerrainProviderOptions,
} from 'angular-cesium';

@Component({
    selector: 'app-maps-provider',
    templateUrl: './maps-provider.component.html',
    styleUrls: ['./maps-provider.component.scss'],
})
export class MapsProviderComponent implements OnInit {
    MapLayerProviderOptions = MapLayerProviderOptions;
    MapTerrainProviderOptions = MapTerrainProviderOptions;
    Cesium = Cesium;

    // MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoidHJpdmVjdG9yeCIsImEiOiJja2g2cWhqZjYwYmQzMnpsMmF6MDI5b29nIn0.q37oXpOmezJCRhsGqWXaUw';
    // MAPBOX_STYLE_ID = 'cjt4h88g007vq1fn72lnen5yo';
    // MAPBOX_USERNAME = 'trivectorx';
    // MAPBOX_STYLE_URL = 'https://api.mapbox.com/styles/v1/' + this.MAPBOX_USERNAME + '/' + this.MAPBOX_STYLE_ID + '/tiles/256/{z}/{x}/{y}?access_token=' + this.MAPBOX_ACCESS_TOKEN;

    WORLD_IMAGERY_URL =
        'https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/WMTS/1.0.0/WMTSCapabilities.xml';
    WORLD_OCEAN_BASE_URL =
        'https://services.arcgisonline.com/arcgis/rest/services/Ocean/World_Ocean_Base/MapServer/WMTS/1.0.0/WMTSCapabilities.xml';

    constructor() {}

    ngOnInit(): void {}
}
